/** @format */

import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import locationServices from '../../../Services/locationServices';
import { ChangeStatus } from '../../../Components';
import ReactPaginate from 'react-paginate';
import Loader from '../../../Components/Loader';
import { MdEdit } from 'react-icons/md';
import Select from 'react-select';
import { useContextCrud } from '../../../ContextManagement/ContextManager';
import { useLocation } from 'react-router-dom'
import CheckAccess from '../../../Function/CheckAccess';

// Storage.set('pageNum', 1);
let currentPage1 = 1;

export const CountryList = () => {

  const { setCountryDetail, countryDetail } = useContextCrud();

  const [countryList, setCountryList] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pagination, setPagination] = useState({ limit: 10 });
  const [loader, setLoader] = useState(true);
  const history = useHistory();


  const location = useLocation()
  let user_type = localStorage.getItem("user_type")

  useEffect(() => {
    getCountryList();
    getFilterCountryList();
  }, []);

  const getFilterCountryList = () => {
    let param = { page: 1, limit: 300 };
    locationServices.getCountry(param).then((res) => {
      let arry = [{ value: '', label: 'All country' }];
      res.data.map((item) => {
        arry.push({ value: item._id, label: item.country_name })
      });
      setCountryData(arry);
    });
  };

  const getCountryList = (country = countryDetail.country_name?.label, currentPage = currentPage1) => {
    let param = {
      page: currentPage,
      limit: pagination.limit,
    };

    if (country && country !== "All country") {
      param.search = country;
    }
    setLoader(true);
    locationServices.getCountry(param).then((res) => {
      if (res.status) {
        setLoader(false);
        setCountryList(res.data);
        setPagination(res.pagination);
      } else {
        setLoader(false);
      }
    });
    // Storage.set('pageNum', 1);
  };

  const onModalSubmit = () => {
    let postData = {
      country_id: isModalOpen._id,
      country_status:
        isModalOpen.country_status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE',
    };
    locationServices.updateCountryStatus(postData).then((res) => {
      if (res.status) {
        setIsModalOpen(false);
        getCountryList();
      }
    });
  };

  const onPageChangeEvent = (e) => {
    currentPage1 = e.selected + 1
    getCountryList(countryDetail.country_name?.label, e.selected + 1);
    setCountryDetail({
      ...countryDetail,
      page: e.selected + 1
    })
  };

  const onChangeCountry = (e) => {
    getCountryList(e.label, 1);
    setCountryDetail({
      ...countryDetail,
      country_name: e,
      page: 1
    })
  };

  return (
    <div className='row'>
      <div className='col-lg-12'>
        <div className='card'>
          <div className='card-body'>
            <div className='d-flex  mb-3 table_filter'>
              <div className='mb-3'>
                <label className='form-label'>Country name</label>
                <Select
                  styles={{
                    valueContainer: (provided) => ({
                      ...provided,
                      height: 'calc(2.15rem + 2px)',
                      overflowY: 'visible',
                    }),
                    control: (provider) => ({
                      ...provider,
                      width: '200px',
                      boxShadow: '0 0 0 0px #f46a6a',
                    }),
                    placeholder: (provider) => ({
                      ...provider,
                      color: '#a0b0ca',
                    }),
                  }}
                  value={countryDetail.country_name}
                  onChange={(e) => onChangeCountry(e)}
                  options={countryData}
                />
              </div>
              {
                (CheckAccess(31,"add") ||  user_type === "SUPERADMIN" )&& 

              <button
                className='btn btn-primary w-sm waves-effect waves-light'
                onClick={() => history.push('/add-country')}
              >
                Add Country
              </button>
              }
            </div>
            <div className='table-responsive'>
              <table className='table table-centered table-nowrap mb-0'>
                <thead className='table-light'>
                  <tr>
                    <th>S.No.</th>
                    <th>Name </th>
                    <th>
                      Air
                      <br /> Port{' '}
                    </th>
                    <th>
                      Air
                      <br /> Door{' '}
                    </th>
                    <th>
                      Air <br />
                      Cons
                    </th>
                    <th>
                      Air <br />
                      On Request
                    </th>

                    <th>
                      Sea <br />
                      Port{' '}
                    </th>
                    <th>
                      Sea <br />
                      Door
                    </th>
                    <th>
                      Sea <br />
                      Cons{' '}
                    </th>
                    <th>
                      Sea <br />
                      On Request
                    </th>

                    {/* <th>Courier<br /> Port </th> */}
                    <th>
                      Courier
                      <br /> Door{' '}
                    </th>
                    <th>
                      Courier
                      <br /> Cons
                    </th>
                    {/* <th>Courier <br />On Request</th> */}

                    {/* <th >Land <br />Port </th> */}
                    <th>
                      Land <br />
                      Door{' '}
                    </th>
                    <th>
                      Land <br /> TT
                    </th>
                    <th>
                      {' '}
                      Land <br />
                      Cons
                    </th>
                    <th>
                      Land <br /> Consolidation TT
                    </th>
                    <th>
                      Land <br />
                      On Request
                    </th>
                    {/* <th>Currency code</th>
                                        <th>Dial code</th> */}
                    {/* <th>Iso2</th> */}
                    {/* <th>Iso3</th> */}
                    <th className='px-1'>Status</th>
                    <th className='px-1'>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {countryList.length > 0 &&
                    countryList.map((item, key) => (
                      <tr key={key}>
                        <td className='text-body fw-bold'>
                          {(countryDetail.page - 1) * pagination.limit + (key + 1)}
                        </td>
                        <td
                          className='px-1'
                          style={{ whiteSpace: 'break-spaces' }}
                        >
                          {item.country_name}
                        </td>

                        <td className='px-1'>
                          <span
                            className={
                              'badge rounded-pill font-size-12' +
                              (item.is_air_port_available === true
                                ? ' bg-soft-success'
                                : ' bg-soft-danger')
                            }
                          >
                            {item.is_air_port_available === true ? 'Yes' : 'No'}
                          </span>
                        </td>
                        <td className='px-1'>
                          <span
                            className={
                              'badge rounded-pill font-size-12' +
                              (item.is_air_door_available === true
                                ? ' bg-soft-success'
                                : ' bg-soft-danger')
                            }
                          >
                            {item.is_air_door_available === true ? 'Yes' : 'No'}
                          </span>
                        </td>
                        <td className='px-1'>
                          <span
                            className={
                              'badge rounded-pill font-size-12' +
                              (item.is_air_consolidation_available === true
                                ? ' bg-soft-success'
                                : ' bg-soft-danger')
                            }
                          >
                            {item.is_air_consolidation_available === true
                              ? 'Yes'
                              : 'No'}
                          </span>
                        </td>
                        <td className='px-1'>
                          <span
                            className={
                              'badge rounded-pill font-size-12' +
                              (item.air_on_request === true
                                ? ' bg-soft-success'
                                : ' bg-soft-danger')
                            }
                          >
                            {item.air_on_request === true ? 'Yes' : 'No'}
                          </span>
                        </td>

                        <td className='px-1'>
                          <span
                            className={
                              'badge rounded-pill font-size-12' +
                              (item.is_sea_port_available === true
                                ? ' bg-soft-success'
                                : ' bg-soft-danger')
                            }
                          >
                            {item.is_sea_port_available === true ? 'Yes' : 'No'}
                          </span>
                        </td>
                        <td className='px-1'>
                          <span
                            className={
                              'badge rounded-pill font-size-12' +
                              (item.is_sea_door_available === true
                                ? ' bg-soft-success'
                                : ' bg-soft-danger')
                            }
                          >
                            {item.is_sea_door_available === true ? 'Yes' : 'No'}
                          </span>
                        </td>
                        <td className='px-1'>
                          <span
                            className={
                              'badge rounded-pill font-size-12' +
                              (item.is_sea_consolidation_available === true
                                ? ' bg-soft-success'
                                : ' bg-soft-danger')
                            }
                          >
                            {item.is_sea_consolidation_available === true
                              ? 'Yes'
                              : 'No'}
                          </span>
                        </td>
                        <td className='px-1'>
                          <span
                            className={
                              'badge rounded-pill font-size-12' +
                              (item.sea_on_request === true
                                ? ' bg-soft-success'
                                : ' bg-soft-danger')
                            }
                          >
                            {item.sea_on_request === true ? 'Yes' : 'No'}
                          </span>
                        </td>

                        {/* <td className="px-1">
                                                <span className={"badge rounded-pill font-size-12" + (item.is_courier_port_available === true ? ' bg-soft-success' : ' bg-soft-danger')}>
                                                    {item.is_courier_port_available === true ? 'Yes' : 'No'}
                                                </span>
                                            </td> */}
                        <td className='px-1'>
                          <span
                            className={
                              'badge rounded-pill font-size-12' +
                              (item.is_courier_door_available === true
                                ? ' bg-soft-success'
                                : ' bg-soft-danger')
                            }
                          >
                            {item.is_courier_door_available === true
                              ? 'Yes'
                              : 'No'}
                          </span>
                        </td>
                        <td className='px-1'>
                          <span
                            className={
                              'badge rounded-pill font-size-12' +
                              (item.is_land_consolidation_available === true
                                ? ' bg-soft-success'
                                : ' bg-soft-danger')
                            }
                          >
                            {item.is_land_consolidation_available === true
                              ? 'Yes'
                              : 'No'}
                          </span>
                        </td>
                        {/* <td className="px-1">
                                                <span className={"badge rounded-pill font-size-12" + (item.courier_on_request === true ? ' bg-soft-success' : ' bg-soft-danger')}>
                                                    {item.courier_on_request === true ? 'Yes' : 'No'}
                                                </span>
                                            </td> */}
                        {/* <td className="px-1">
                                                <span className={"badge rounded-pill font-size-12" + (item.is_land_port_available === true ? ' bg-soft-success' : ' bg-soft-danger')}>
                                                    {item.is_land_port_available === true ? 'Yes' : 'No'}
                                                </span>
                                            </td> */}

                        <td className='px-1'>
                          <span
                            className={
                              'badge rounded-pill font-size-12' +
                              (item.is_land_door_available === true
                                ? ' bg-soft-success'
                                : ' bg-soft-danger')
                            }
                          >
                            {item.is_land_door_available === true
                              ? 'Yes'
                              : 'No'}
                          </span>
                        </td>
                        <td className='px-1'>{item.land_transit_time}</td>
                        <td className='px-1'>
                          <span
                            className={
                              'badge rounded-pill font-size-12' +
                              (item.is_land_consolidation_available === true
                                ? ' bg-soft-success'
                                : ' bg-soft-danger')
                            }
                          >
                            {item.is_land_consolidation_available === true
                              ? 'Yes'
                              : 'No'}
                          </span>
                        </td>
                        <td className='px-1'>{item.land_consolidation_transit_time}</td>
                        <td className='px-1'>
                          <span
                            className={
                              'badge rounded-pill font-size-12' +
                              (item.land_on_request === true
                                ? ' bg-soft-success'
                                : ' bg-soft-danger')
                            }
                          >
                            {item.land_on_request === true ? 'Yes' : 'No'}
                          </span>
                        </td>
                        {/* <td>{item.country_currency}</td>
                                            <td>{item.country_dial_code}</td> */}
                        {/* <td>{item.country_iso2}</td>
                                            <td>{item.country_iso3}</td> */}
                        <td className='px-1'>
                          <span
                            className={
                              'badge rounded-pill font-size-12 pointer' +
                              (item.country_status === 'ACTIVE'
                                ? ' bg-success'
                                : ' bg-soft-danger')
                            }
                            onClick={() => setIsModalOpen(item)}
                          >
                            {item.country_status}
                          </span>
                        </td>
                        <td className='px-1'>
                          {/* Button trigger modal */}
                          {/* <button type="button" className="btn btn-warning btn-sm btn-rounded waves-effect waves-light">
                                                    View
                                                </button> */}
                          {/* <button
                                                    type="button"
                                                    className="m-1 btn btn-primary btn-sm btn-rounded waves-effect waves-light"
                                                    >
                                                    Edit
                                                </button> */}
                                                {
                                                   (CheckAccess(31,"edit") || user_type === "SUPERADMIN") && 

                          <MdEdit
                            className='pointer'
                            onClick={() => {
                              // Storage.set('pageNum', currentPage);
                              history.push('/edit-country?id=' + item._id);
                            }}
                            color='#0323fe'
                            size='25px'
                          />
                                                }
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              {countryList.length <= 0 && !loader && (
                <div className='text-center w-100 bg-warning my-5'>
                  <h6 className='py-2'> list not available </h6>
                </div>
              )}
            </div>
          </div>
          {countryList.length > 0 &&
            pagination.totalRecord > pagination.limit && (
              <ReactPaginate
                previousLabel={
                  <img
                    src='assets/images/prev.svg'
                    height={15}
                    alt='not found'
                  />
                }
                forcePage={countryDetail.page - 1}
                nextLabel={
                  <img
                    src='assets/images/next.svg'
                    height={15}
                    alt='not found'
                  />
                }
                breakLabel={'...'}
                breakClassName={'break-me'}
                pageCount={Math.ceil(pagination.totalRecord / pagination.limit)}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={(e) => onPageChangeEvent(e)}
                containerClassName={'pagination'}
                activeClassName={'active'}
              />
            )}
          {/* {loader &&  */}
          <Loader isShow={loader} />
          {/* } */}
        </div>
      </div>
      {Boolean(isModalOpen) && (
        <ChangeStatus
          isOpen={Boolean(isModalOpen)}
          title='Update Status'
          message={`Are you sure want to ${isModalOpen.country_status === 'ACTIVE' ? 'Inactive' : 'Active'
            } to ${isModalOpen.country_name}?`}
          // message={`Are you sure want to ${isModalOpen.country_status  === 'ACTIVE' ? 'Inactive' : 'Active'} status ?`}
          onSubmitEvent={() => onModalSubmit()}
          handleClose={() => setIsModalOpen(false)}
        />
      )}
    </div>
  );
};
